export interface Slides {
  id: number;
  url: string;
  content: string;
  default: boolean;
}

export const getDefaultIndex = (slides: Slides[]) =>
  slides.findIndex((slide) => slide.default) || 0;

export const goToNextSlide = (prevIndex: number, slidesLength: number) => {
  const newIndex = (prevIndex + 1) % slidesLength;
  return newIndex;
};

export const goToPrevSlide = (prevIndex: number, slidesLength: number) => {
  const newIndex = (prevIndex - 1 + slidesLength) % slidesLength;
  return newIndex;
};

export function createHandleThumbnailClick(
  setCurrentIndex: (index: number) => void
) {
  return (index: number) => (e: React.MouseEvent<HTMLElement>) => {
    setCurrentIndex(index);
    e.currentTarget.focus();
    e.stopPropagation();
    e.currentTarget.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest',
    });
  };
}

export function handleTracerClick(
  index: number,
  thumbnailContainerRefs: (HTMLDivElement | null)[]
) {
  if (thumbnailContainerRefs[index]) {
    thumbnailContainerRefs[index]?.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest',
    });
  }
}

export const keyboardEvent = (
  event: React.KeyboardEvent,
  callback: () => void
) => {
  if (event.key === 'Enter') {
    callback();
  }
};

// determine which thumbnail is centered on the thumbnail wrapper
export function handleWrapperScroll(
  thumbnailWrapperRef: HTMLDivElement | null,
  thumbnailContainerRefs: (HTMLDivElement | null)[],
  setCurrentIndex: (index: number) => void
) {
  const wrapper = thumbnailWrapperRef;
  if (!wrapper) return;

  const children = thumbnailContainerRefs;
  let minDiff = Infinity;
  let activeIndex = 0;
  const wrapperRect = wrapper.getBoundingClientRect();

  // calculate the center point of each child and compare it to the wrapper's center point
  children.forEach((child, idx) => {
    if (!child) return;
    const rect = child.getBoundingClientRect();
    const diff = Math.abs(
      (rect.left + rect.right) / 2 - (wrapperRect.left + wrapperRect.right) / 2
    );
    if (diff < minDiff) {
      minDiff = diff;
      activeIndex = idx;
    }
  });

  setCurrentIndex(activeIndex);
}
